module.exports = __webpack_public_path__ + "img/fb-icon.51d371c1.png";